// Centralised site data: Accounting & Tax department only.
export const SITE = {
  name: "St. John Accounting & Tax",
  parent: "St. John Financial Group",
  tagline: "Trusted accounting & tax guidance, since 2004.",
  phone: "(918) 212-9590",
  phoneTel: "tel:9182129590",
  fax: "(918) 274-0605",
  email: "David@stjohnfinancialgroup.com",
  address: {
    street: "9500 N 129th E Ave #123",
    cityStateZip: "Owasso, OK 74055",
    mapUrl:
      "https://www.google.com/maps/place/St.+John+Accounting+and+Tax/@36.2913622,-95.8337982,917m/data=!3m3!1e3!4b1!5s0x87b6f0a123e2c203:0x156bcc52d6d5003b!4m6!3m5!1s0x87b6f0a123cf5d13:0xca8cd1844830e74a!8m2!3d36.2913622!4d-95.8312233",
  },
  social: {
    facebook: "https://www.facebook.com/stjohnfinancialgroup",
    linkedin: "https://www.linkedin.com/in/stjohnfinancialgroup/",
  },
  bookingUrl:
    "https://outlook.office.com/book/StJohnFinancialGroup@stjohnfinancialgroup.com/",
  // Related sister services. Referenced in navbar dropdown ("Related Services") and footer.
  otherCompanies: [
    { name: "St. John Financial Group", url: "https://www.stjohnfinancialgroup.com/", desc: "Financial planning & wealth management" },
    { name: "St. John Insurance", url: "https://www.stjohninsurance.net/", desc: "Personal & commercial insurance" },
  ],
  trust: {
    chamber:
      "http://owassochamber.chambermaster.com/list/member/st-john-financial-group-inc-709",
    bbb: "http://www.bbb.org/tulsa/business-reviews/insurance-companies/st-john-financial-group-inc-in-owasso-ok-20000423",
    chamberLogo: "/files/owasso-chamber.jpg",
    bbbLogo: "/files/bbb.jpg",
    proadvisorBadge: "/files/intuit-proadvisor-platinum.png",
  },
  files: {
    accountingChecklist: "/files/AT-Services-WWD.pdf",
    cfoChecklist: "/files/CFO-BD-WWD.pdf",
    intakeForm: "/files/TS-Intake-Sign-18.pdf",
    davidResume: "/files/DSJ-resume.pdf",
    taxAppointmentChecklist: "/files/Tax-Appointment-Checklist.doc",
  },
  // Accounting & Tax department services, plus our two sister St. John firms (03, 04) accessible via direct link.
  services: [
    {
      number: "01",
      title: "Business Accounting & Payroll Services",
      desc: "Accurate accounting and reliable payroll for small businesses. We keep your records clean for clearer financial decisions and we keep your team paid on time.",
      icon: "Briefcase",
    },
    {
      number: "02",
      title: "Tax Planning & Preparation",
      desc: "Businesses & Individuals, Federal & State. Filings that are accurate, complete, and on time.",
      icon: "Receipt",
    },
    {
      number: "03",
      title: "Insurance Services",
      desc: "Commercial and Personal insurance through St. John Insurance. Providing peace of mind to businesses and families through customized insurance solutions.",
      icon: "Shield",
      external: "https://www.stjohninsurance.net/",
    },
    {
      number: "04",
      title: "Financial Planning & Wealth Management",
      desc: "Professional financial planning and wealth management through St. John Financial Group, Inc. Long-term financial strategies aligned with your lifetime goals and dreams.",
      icon: "TrendingUp",
      external: "https://www.stjohnfinancialgroup.com/",
    },
  ],
  benefits: [
    "One-stop, multi-professional resource for integrated business decisions.",
    "Financial analysis to help evaluate cash flow, gross revenue, gross profit, operating profit, and net profit.",
    "Expert operational analysis designed to identify opportunities to improve efficiency and effectiveness.",
    "Outsourced accounting and payroll services that reduce administrative workload.",
    "Accurate, timely accounting information so you can make better business decisions.",
    "Freedom to focus on operating and growing your business.",
    "Business transition planning: optimizing the transfer of business leadership and ownership.",
  ],
  team: {
    principle: {
      name: "David St. John",
      title: "Principal Advisor",
      credentials: "MBA, EA, MSAcct/Tax, CFP®",
      photo: "/images/david-portrait.jpg",
      phone: "(918) 212-9590",
      email: "David@stjohnfinancialgroup.com",
      resume: "/files/DSJ-resume.pdf",
    },
    bio: [
      '"Living the dream" for David is living in a small town and growing a small business focused on peace, prosperity, and professionalism.',
      "Happily married for over fifty years with two sons and five grandchildren, David feels like he has hit the best jackpot ever: the Family Fortune 500 jackpot.",
    ],
    associates: [
      { name: "Theresa Russell", email: "Theresa@stjohnfinancialgroup.com", photo: "/images/team-theresa.jpg" },
      { name: "Sonya Olvera", email: "Sonya@stjohnfinancialgroup.com", photo: "/images/team-sonya.jpg" },
      { name: "Lori Stierwalt", email: "Lori@stjohnfinancialgroup.com", photo: "/images/team-lori.jpg" },
      { name: "Kylee Benham", email: "Kylee@stjohnfinancialgroup.com", photo: "/images/team-kylee.jpg" },
    ],
  },
  logo: "/images/logo-circle.png",
};
